import { useState } from "react";

import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

interface IResult {
    isRequestInProgress: boolean;
    requestFeature: (featureKey: string) => Promise<Response>;
}

function useRequestFeatureHookWithLoading(): IResult {
    const [isRequestInProgress, setIsRequestInProgress] = useState(false);

    const handleHookRequest = async (featureKey: string): Promise<Response> => {
        setIsRequestInProgress(true);

        try {
            return await requestFeature(featureKey);
        } finally {
            setIsRequestInProgress(false);
        }
    };

    return {
        isRequestInProgress,
        requestFeature: handleHookRequest,
    };
}

export default useRequestFeatureHookWithLoading;
